import {
  GAME_ID,
  REDUX_ACTIONS,
} from '../../data/planTorresConstants';

const initialState = {
  // array of levels
  levels: [],
  // id of current level, starts from 0
  currentLevelId: null,
};

// need toppers to appear for every level except 1st for questions number 1 and 3
const isTopperItem = (levelId, questionIndex) => (levelId > 0 && (questionIndex === 1 || questionIndex === 3));

const planTorresCurriculumReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.LOAD_CURRICULUM: {
      const { curriculum: { levels }, levelsToppers } = action.payload;
      let topperCounter = 0;

      return {
        ...initialState,
        levels: levels.map(level => ({
          ...level,
          standardItems: level.standardItems.map((question, questionIndex) => ({
            ...question,
            // if this is topper question, pick topper id
            topperId: isTopperItem(level.id, questionIndex) ? levelsToppers[topperCounter++] : null,
          })),
          // progress threshold user should reach in order to be mastered in round for this level
          masteredLevelThreshold: Math.round(level.standardItems.length * 0.8),
        })),
      };
    }
    case REDUX_ACTIONS.SELECT_LEVEL: {
      return {
        ...state,
        currentLevelId: action.payload,
      };
    }
    default:
      return state;
  }
};

export default planTorresCurriculumReducer;
